export class RunJobTemplateResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "runId",
            "baseName": "runId",
            "type": "string",
            "format": ""
        },
        {
            "name": "engineName",
            "baseName": "engineName",
            "type": "string",
            "format": ""
        },
        {
            "name": "jobName",
            "baseName": "jobName",
            "type": "string",
            "format": ""
        },
        {
            "name": "scheduledFor",
            "baseName": "scheduledFor",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return RunJobTemplateResponse.attributeTypeMap;
    }
    constructor() {
    }
}
